// React / Next
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

// Components
import { ResourcesPage } from '../pages/ResourcesPage/ResourcesPage';
import { ResourcesPageSkeleton } from '../components/Skeletons';

// Sanity
import { getFilteredArticles, getAllCategories, getAllAuthors } from '../lib/sanity';

// Types
import type { ArticleType } from '../lib/sanity';

const resourceSearchSchema = z.object({
  type: z.enum(['playbook', 'news', 'article']).optional(),
  category: z.string().optional(),
  author: z.string().optional(),
  search: z.string().optional(),
});

export const Route = createFileRoute('/resources')({
  component: ResourcesPage,
  pendingComponent: ResourcesPageSkeleton,
  validateSearch: resourceSearchSchema,
  loaderDeps: ({ search }) => ({
    type: search.type,
    category: search.category,
    author: search.author,
  }),
  loader: async ({ deps }) => {
    const { type, category, author } = deps;
    
    try {
      const [articles, categories, authors] = await Promise.all([
        getFilteredArticles({
          type: type as ArticleType | undefined,
          categorySlug: category,
          authorSlug: author,
        }),
        getAllCategories(),
        getAllAuthors(),
      ]);

      return { articles, categories, authors };
    } catch (error) {
      console.error('Error loading resources:', error);
      return { articles: [], categories: [], authors: [] };
    }
  },
});

